import { Accordion, Box, Tab, Tabs, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { ICv } from "../../../../commons/types/crm";
import { a11yProps, AccordionDetails, AccordionSummary, CustomTabPanel } from "../../../../components/Tabs/accordionAndTabPanel";
import { useCvActions } from "../../../../states/contatos/auxiliares/cvs/cv.actions";
import AnexosDetalhes from "./anexos";
import Curriculos from "./curriculos";
import { useTranslation } from "../../../../commons/useTranslasion";
import { ptBR, esES } from "@mui/material/locale";

const Anexo: React.FC = () => {
  const { translate, language } = useTranslation();
  const lang = language ?? "pt-br";
  let locale = ptBR;
  switch (lang.slice(0, 2)) {
    case "es":
      locale = esES
      break;
  }

  useEffect(() => { }, [])

  return (
    <Box>
      <Accordion defaultExpanded style={{ borderRadius: '10px' }}>
        <AccordionSummary
          aria-controls='cvs-content'
          id='cvs-header'
        >
          <Typography>{translate('cvs')}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Curriculos />
        </AccordionDetails>
      </Accordion>

      <Accordion defaultExpanded style={{ borderRadius: '10px' }}>
        <AccordionSummary
          aria-controls='anexos-content'
          id='cvs-header'
        >
          <Typography>{translate('anexos')}</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <AnexosDetalhes />
        </AccordionDetails>
      </Accordion>
    </Box>
  )
}

export default Anexo;

